import axios from 'axios'
import routesConfig from 'routesConfig';

const instanceAxios = axios.create({
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },
    baseURL: routesConfig.apiGateway + 'api/PSE'

});

export default instanceAxios